<div class="maintenance-container">
    <div>
        <div>
            <img
                alt="404 NOT FOUND"
                class="illustration m-t-10"
                src="assets/images/illustrations/error.svg"
            />
        </div>

        <div class="content">
            <p
                class="title"
                i18n
            >
                We're coming back
            </p>
            <p
                class="accent-text"
                i18n
            >
                We are performing some maintenance work on the portal.
            </p>
        </div>
    </div>
</div>
